<apps-header
  (loadMenuItems)="loadMenuItems()"
  (clearNotifications)="clearNotifications()"
  (toggleEditMode)="toggleEditMode()"
  (unhideApp)="unhide($event)"
  (unhideAll)="unhideAll()"
  [isEditMode]="isEditMode"
  [hiddenApps]="hiddenApps"
  [isWebView]="isWebView"
  [isMainMenuView]="true"
  [headerUserFirstName]="userFirstName"
></apps-header>
<user-status></user-status>
<critical-alerts></critical-alerts>

<div class="menu-outer container" [style.height]="menuOuterHeight" [ngStyle]="{'background-color': isWebView ?  'white' : 'var(--header-blue)'}">
  <div class="greeting">
    @if (userFirstName) {
      <div class="greeting-text" [ngStyle]="{'color': isWebView ? 'var(--header-blue)' : 'white'}">
        <h1 rtI18n [rtI18nParams]="{ name: userFirstName }">Hello, [[name]]</h1>
        @if (showGuidedTour) {
          <button type="button" [matMenuTriggerFor]="guidedTourMenu" class="get-started-btn">
            <i class="icon-running icon-action-blue"></i>
            <span rtI18n>New? Start here</span>
          </button>
          <mat-menu #guidedTourMenu="matMenu" class="guided-tour-menu">
            <button type="button" mat-menu-item (click)="startMainMenuTour()" rtI18n>Where do I start?</button>
            <button type="button" mat-menu-item (click)="startProfileTour()" rtI18n>Set up your Profile</button>
            @if (canAccessMessages) {
              <button type="button" mat-menu-item (click)="startMessageTour()" rtI18n>Send a Message</button>
            }
            @if (canCreatePost) {
              <button type="button" mat-menu-item (click)="startPostTour()" rtI18n>Create a Post</button>
            }
            @if (canViewPostsReadOnly) {
              <button type="button" mat-menu-item (click)="startGuardianPostTour()" rtI18n>Browse Posts</button>
            }
            <mat-divider></mat-divider>
            <button type="button" mat-menu-item class="dont-show-item" (click)="hideGuidedTour()" rtI18n>Don't show this again</button>
          </mat-menu>
        }
      </div>
    }
  </div>

  <div class="dashboard-outer">
    <div class="main-content">
      @if (hasStudents) {    
        <div class="students-container">
          <div class="students-header home-sub-header" rtI18n>
            Your students
          </div>
          <div class="student-cards-container" #studentCarousel (scroll)="onCarouselScroll(studentCarousel, 'students')">
            @if (parentPortalStudentServiceStatus === ServiceStatus.loading) {
              <div class="loading-outer">
                <mat-spinner class="spinner" [diameter]="50">
                </mat-spinner>
              </div>
            }
            @for (student of parentPortalStudents; track student.UserID) {
              <div class="student-card-stack">
                @if (getVisibleRecords(student).length > 1) {
                  <button type="button" class="record-pager"
                    [attr.aria-label]="isAtLastRecord(student) ? 'Previous school' : 'Next school'"
                    (click)="cycleRecord(student, isAtLastRecord(student) ? -1 : 1); $event.stopPropagation()">
                    @if (isAtLastRecord(student)) {
                      <i class="icon-chevron-left icon-white"></i>
                    }
                    <span>{{getActiveRecordIndex(student) + 1}}/{{getVisibleRecords(student).length}}</span>
                    @if (!isAtLastRecord(student)) {
                      <i class="icon-chevron-right icon-white"></i>
                    }
                  </button>
                }
                <div class="student-card card">
                  <!-- A record in the enrollment funnel gets its stage card INSTEAD of the
                       regular rows (mirrors the portal's strict if/else student card). -->
                  @if (getActiveStage(student); as stage) {
                    @if (getActiveRecord(student); as record) {
                      @switch (stage) {
                        @case (EnrollmentCardStage.Applied) {
                          <div class="stage-card stage-applied">
                            <div class="stage-icon-circle"><i class="icon-clipboard-check icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]]'s application has been received!</div>
                              <div class="stage-subtitle">{{record.SchoolShortName}} · {{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>Thanks for your interest! We'll share more updates soon.</div>
                            </div>
                          </div>
                        }
                        @case (EnrollmentCardStage.Accepted) {
                          <div class="stage-card stage-accepted clickable" (click)="openEnrollmentVerification()">
                            <div class="stage-icon-circle"><i class="icon-circle-check icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]] has been accepted!</div>
                              <div class="stage-subtitle">{{record.SchoolShortName}} · {{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>Congratulations! Complete the next steps to reserve your child's seat.</div>
                              <span class="btn btn-header btn-small stage-btn" rtI18n>Get Started</span>
                            </div>
                          </div>
                        }
                        @case (EnrollmentCardStage.AcceptedMultiple) {
                          <div class="stage-card stage-accepted clickable" (click)="openEnrollmentVerification()">
                            <div class="stage-icon-circle"><i class="icon-circle-check icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]] has been accepted to multiple schools!</div>
                              <div class="stage-subtitle">{{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>Congratulations! Complete the next steps to accept or decline your child's seat.</div>
                              <span class="btn btn-header btn-small stage-btn" rtI18n>Get Started</span>
                            </div>
                          </div>
                        }
                        @case (EnrollmentCardStage.Registered) {
                          <div class="stage-card stage-registered clickable" (click)="openRegistrationForms(record)">
                            <div class="stage-icon-circle"><i class="icon-form icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]]'s seat is reserved!</div>
                              <div class="stage-subtitle">{{record.SchoolShortName}} · {{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>Finish your child's registration so they're ready for their first day of school.</div>
                              <span class="btn btn-header btn-small stage-btn" rtI18n>Finish Registration</span>
                            </div>
                          </div>
                        }
                        @case (EnrollmentCardStage.RegistrationComplete) {
                          <div class="stage-card stage-complete clickable" (click)="openRegistrationCompleteDialog(student, record)">
                            <div class="stage-icon-circle"><i class="icon-star-filled icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]]'s registration is complete!</div>
                              <div class="stage-subtitle">{{record.SchoolShortName}} · {{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>All set! We're excited to welcome them on their first day of school.</div>
                              <span class="btn btn-header btn-small stage-btn" rtI18n>View Next Steps</span>
                            </div>
                          </div>
                        }
                        @case (EnrollmentCardStage.Waitlist) {
                          <div class="stage-card stage-waitlist clickable" (click)="openEnrollmentVerification()">
                            <div class="stage-icon-circle"><i class="icon-clock icon-white"></i></div>
                            <div class="stage-body">
                              <div class="stage-title" rtI18n [rtI18nParams]="{ name: student.FirstName }">[[name]] is on the waiting list!</div>
                              <div class="stage-subtitle">{{record.SchoolShortName}} · {{record.GradeLevelName}} · {{record.AcademicYearName}}</div>
                              <div class="stage-message" rtI18n>Hang tight! Your child is on the waiting list, but there's a lot of movement. We'll reach out right away if a seat opens up.</div>
                              <span class="btn btn-header btn-small stage-btn" rtI18n>Check Waitlist</span>
                            </div>
                          </div>
                        }
                      }
                    }
                  } @else {
                    <div class="title-row" (click)="openStudentHome(student)">
                      <user-image
                        #studentUserImage
                        [userId]="student.UserID"
                        [profileEnabled]="false"
                        [isCircle]="true"
                        [size]="'48px'">
                      </user-image>
                      <div class="name-school-column">
                        <div class="student-name">
                          {{student.FirstName}} {{student.LastName}}
                        </div>
                        <div class="school-info">
                          @if (getActiveRecord(student); as record) {
                            <div class="school-name">
                              {{record.GradeLevelName}} · {{record.SchoolShortName}}
                            </div>
                            @if (record.MasterStatusID === EnrollmentMasterStatus.Enrolled) {
                              <span class="status-pill enrolled" rtI18n
                                [rtI18nParams]="{ year: yearPillLabel(record.AcademicYearName) }">Enrolled · [[year]]</span>
                            } @else if (record.MasterStatusID === EnrollmentMasterStatus.ReEnrolled) {
                              <span class="status-pill re-enrolled" rtI18n
                                [rtI18nParams]="{ year: yearPillLabel(record.AcademicYearName) }">Re-Enrolled · [[year]]</span>
                            }
                          }
                        </div>
                      </div>
                      <div class="arrow">
                        <i class="icon-chevron-right icon-text-blue" style="width: 14px; height: 14px;"></i>
                      </div>
                    </div>
                    @if (getActiveRecord(student); as record) {
                      @if (showMealBalance(student, record)) {
                        <div class="lunch-money">
                          <i class="icon-fork-spoon icon-text-blue" style="width: 14px; height: 14px;"></i>
                          <div rtI18n>Meal Balance: </div>
                          <div class="amount">{{(record.MealBalance ?? 0) | currency}}</div>
                          <button type="button" class="btn btn-link btn-small add-btn" rtI18n
                            (click)="addToMealBalance(record); $event.stopPropagation()">Add</button>
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            }
          </div>
          @if (parentPortalStudents.length > 1) {
            <div class="carousel-dots">
              @for (student of parentPortalStudents; track student.UserID; let i = $index) {
                <button type="button" class="dot" [class.active]="i === studentCarouselIndex"
                  [attr.aria-label]="'Go to student ' + (i + 1)"
                  (click)="scrollCarouselTo(studentCarousel, i)"></button>
              }
            </div>
          }
        </div>
      }

      <div class="apps-container">
        <div class="apps-header-row">
          <div class="apps-header home-sub-header" rtI18n>
            Your apps
          </div>
          @if (!isEditMode) {
            <button type="button" class="btn btn-icon btn-small edit-apps-btn" (click)="toggleEditMode()">
              <i class="icon-edit icon-action-blue"></i>
              <span rtI18n>Edit</span>
            </button>
          }
        </div>

        @if (isEditMode) {
          <div class="edit-mode-banner">
            <div class="edit-mode-banner-text" rtI18n>
              Tap eye to show/hide · Drag to reorder · Drag to the bar to pin
            </div>
            <button type="button" class="btn btn-primary btn-small edit-mode-banner-btn"
              (click)="toggleEditMode()"
              rtI18n>
              Done
            </button>
          </div>
        }

        <!-- The tour anchor lives on a wrapper because CdkDropList reflects its own id onto the
             host, and the grid's id is what the nav row connects to. -->
        <div id="tour-app-icons">
        <div
        id="apps-grid-drop-list"
        class="apps-grid"
        [class.edit-mode]="isEditMode"
        cdkDropList
        cdkDropListOrientation="mixed"
        [cdkDropListConnectedTo]="['header-apps-drop-list', 'footer-apps-drop-list']"
        [cdkDropListEnterPredicate]="canDropInGrid"
        (cdkDropListDropped)="drop($event)">
          @if (!menuItems && menuItemsServiceStatus === ServiceStatus.loading && !menuItemsError) {
            <div class="loading-outer">
              <mat-spinner class="spinner" [diameter]="50">
              </mat-spinner>
            </div>
          }

          @if (menuItems || (menuItemsServiceStatus !== ServiceStatus.loading && menuItemsServiceStatus !== ServiceStatus.unset)) {
            <menu-item id="tour-profile-icon" [menuItem]="profileMenuItem"
              [isEditMode]="false">
            </menu-item>
          }

          @if (menuItemsServiceStatus === ServiceStatus.error) {
            <div class="error-box"
              [matTooltip]="canViewExpandedError ? (menuItemsError?.message ?? '') : ''"
              [matTooltipDisabled]="!canViewExpandedError">
              <div class="error-left">
                <i class="icon-warning icon-red"></i>
              </div>
              <div class="error-right">
                <div class="error-top" rtI18n>There was an error refreshing the main menu.</div>
                <div class="error-bottom">
                  @if (canViewExpandedError) {
                    <span>{{menuItemsError?.status}} {{menuItemsError?.statusText}}</span>
                  } @else {
                    <span rtI18n>Please try again later.</span>
                  }
                </div>
              </div>
            </div>
          }

          @if (menuItems) {
            @for (item of menuItems; track item.Id) {
              @if (item.ItemType === MenuItemType.App) {
                @if (item.SortOrder >= 0) {
                  <div cdkDrag
                    [cdkDragData]="item"
                    [cdkDragDisabled]="!isEditMode"
                    (cdkDragStarted)="onGridDragStarted(item)"
                    (cdkDragEnded)="onGridDragEnded()">
                    <menu-item [menuItem]="item"
                      [isEditMode]="isEditMode"
                      (onToggleVisibilityClick)="onToggleVisibilityClick(item)">
                    </menu-item>
                  </div>
                }
                @if (isEditMode && item.SortOrder === -1) {
                  <div cdkDrag
                    [cdkDragData]="item"
                    [cdkDragDisabled]="!isEditMode"
                    (cdkDragStarted)="onGridDragStarted(item)"
                    (cdkDragEnded)="onGridDragEnded()">
                    <menu-item [menuItem]="item"
                      [isEditMode]="isEditMode"
                      (onToggleVisibilityClick)="onToggleVisibilityClick(item)">
                    </menu-item>
                  </div>
                }
              }
            }
          }

          @if (showCollegeReadiness) {
            <menu-item [menuItem]="collegeReadinessApp"
              [isEditMode]="false">
            </menu-item>
          }

        </div>
        </div>
      </div>
    </div>

    <div class="side-bar">
      @if (isGuardian && todoItems && todoItems.length > 0) {
        <app-todos-section
          class="todos-section"
          [todos]="todoItems"
          [status]="todosServiceStatus"
          [showReenrollment]="showReenrollmentTodo"
          [isImpersonating]="isImpersonating">
        </app-todos-section>
      }


      <div class="schools-container">

        @if (showStaffSchoolSelector) {
          <div class="school-selector-header">
            <app-school-selector [ignoreMobileStyling]="true" (schoolChanged)="onSidebarSchoolChanged($event)"></app-school-selector>
          </div>
        }

        @if (!showStaffSchoolSelector && displayedSchools.length > 1) {
          <nav mat-tab-nav-bar class="school-tabs" [tabPanel]="schoolTabPanel">
            @for (school of displayedSchools; track school.Id; let i = $index) {
              <a mat-tab-link [active]="i === schoolCarouselIndex"
                (click)="scrollCarouselTo(schoolCarousel, i)">{{school.SchoolName}}</a>
            }
          </nav>
          <mat-tab-nav-panel #schoolTabPanel></mat-tab-nav-panel>
        }

        <div class="school-cards-container" #schoolCarousel (scroll)="onCarouselScroll(schoolCarousel, 'schools')">
        @for (school of displayedSchools; track school.Id) {
          <div class="school-stack">
          @if (!showStaffSchoolSelector && displayedSchools.length === 1) {
            <div class="schools-header home-sub-header">
              <i class="icon-school icon-text-blue"></i>
              {{school.SchoolName}}
            </div>
          }
          <app-school-card [school]="school" [gradeOptions]="getGradeOptionsForSchool(school)"></app-school-card>
          </div>
        }
        </div>
        @if (displayedSchools.length > 1) {
          <div class="carousel-dots">
            <button type="button" class="carousel-arrow" aria-label="Previous school"
              [disabled]="schoolCarouselIndex === 0"
              (click)="scrollCarouselTo(schoolCarousel, schoolCarouselIndex - 1)">
              <i class="icon-chevron-left icon-action-blue"></i>
            </button>
            @for (school of displayedSchools; track school.Id; let i = $index) {
              <button type="button" class="dot" [class.active]="i === schoolCarouselIndex"
                [attr.aria-label]="'Go to school ' + (i + 1)"
                (click)="scrollCarouselTo(schoolCarousel, i)"></button>
            }
            <button type="button" class="carousel-arrow" aria-label="Next school"
              [disabled]="schoolCarouselIndex >= displayedSchools.length - 1"
              (click)="scrollCarouselTo(schoolCarousel, schoolCarouselIndex + 1)">
              <i class="icon-chevron-right icon-action-blue"></i>
            </button>
          </div>
        }
      </div>
    </div>


  </div>

  @if (!isWebView) {
    <apps-footer [isEditMode]="isEditMode"
                 [isMainMenuView]="true"
                 (toggleEditMode)="toggleEditMode()"></apps-footer>
  }
</div>


